import CreateIcon from "@mui/icons-material/Create";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary } from "src/components/Default/LekUI/Accordion";

import { useFontSize } from "../../../../hooks/useFontSize";

function Title({ section }) {
	const { fontSizeClass } = useFontSize();
	const renderNoteExistIcon = (section) => {
		return section.note && <CreateIcon color="primary" />;
	};

	return (
		<AccordionSummary expandIcon={<ExpandMoreIcon />}>
			<span className={fontSizeClass}>{section.title}</span>
			{renderNoteExistIcon(section)}
		</AccordionSummary>
	);
}

export default Title;
